let module = 'cemeteries';
let code = 'cem';
let codeAPI = 'cem';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
    module: `${module}`,
};